import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientColorMap } from "../layout/patientColorMap";
import { ReactComponent as EmergencyIcon } from "../assets/emergencyIcon.svg";
import { GenericButton } from "./uiControllers/genericButton";
import { useTranslate } from "../hooks/useTranslate";
import { marginRightToMarginLeftOnRtl } from "fe-web-components/rtl/rtlStyles";
import { ForwardedRef, forwardRef } from "react";

//region [[ Styles ]]

const EmergencyElementView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "10px",
}));

const DisclaimerButton = styled("div")(({ theme }) => ({
  display: "flex",
  "& .only-button": {
    minWidth: "120",
  },
  marginTop: "10px",
  justifyContent: "flex-end",
}));

const EmergencyDisclaimer = styled("div")(({ theme }) => ({
  background: "#F7F7F9",
  borderRadius: "30px",

  padding: "30px",
  display: "flex",
  flexDirection: "column",
  marginBottom: "10px",
}));

const IconContainer = styled("div")({
  ...marginRightToMarginLeftOnRtl(6),
});

const Header = styled("div")(({ theme }) => ({
  fontWeight: "bold",
  color: PatientColorMap.Emergency,
  marginBottom: "10px",
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
}));

const Description = styled("div")(({ theme }) => ({
  marginBottom: "10px",
  fontSize: "15px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface EmergencyElementProps {
  onContinue: () => void;
  answered?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const EmergencyElement = forwardRef(
  ({ ...props }: EmergencyElementProps, ref: ForwardedRef<any>) => {
    const { translate } = useTranslate();

    return (
      <EmergencyElementView>
        <EmergencyDisclaimer>
          <Header>
            <IconContainer>
              <EmergencyIcon />
            </IconContainer>
            {translate("CONCERNING_SYMPTOMS")}
          </Header>
          <Description>{translate("SYMPTOMS_DESCRIPTION")}</Description>
        </EmergencyDisclaimer>
        <DisclaimerButton ref={props.answered ? ref : null}>
          <GenericButton
            className={"primary-button"}
            onClick={props.onContinue}
            label={translate("EMERGENCY_CONTINUE_BUTTON")}
            disabled={props.answered}
          />
        </DisclaimerButton>
      </EmergencyElementView>
    );
  },
);
